/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Agent_Passkey_RevokedInputs */



/**
* | output |
* | --- |
* | "Passkey revoked" |
*
* @param {Profile_Security_Agent_Passkey_RevokedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkey_revoked = /** @type {((inputs?: Profile_Security_Agent_Passkey_RevokedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_Passkey_RevokedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey widerrufen")
	return /** @type {LocalizedString} */ ("Passkey revoked")
});